import Handsontable from "handsontable";
import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit, Renderer2,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {ApiService} from "../../services/api/api.service";
import {HandsontableGeneratorService, HOTLookup} from "../../services/handsontable-generator.service";
import {HeaderDataService} from "../../services/header_data.service";
import * as utils from '../../lib/utils';
import {deepCopy, guid} from '../../lib/utils';
import {DateTimePeriodService} from "../../services/date-time-period.service";
import {TileDataService} from "../../services/tile_data.service";
import {
    catchError,
    concatMap,
    first,
    map,
    switchMap,
    takeUntil,
    tap,
    take,
    delay,
    filter
} from "rxjs/operators";
import {defer, EMPTY, forkJoin, Observable, of, Subject, Subscription, finalize} from "rxjs";
import {HotInstance} from "../../services/hot-instance";
import {EventType} from '../../_models/event-type';
import {NotificationService} from "../../services/notification.service";
import {CustomEventsService} from "../../services/custom-events.service";
import {Component as WireComponent} from "../../_models/component";
import {Event as WireEvent} from "../../_models/event";
import {difference as _difference, uniq as _uniq, uniqBy as _uniqBy} from "lodash-es";
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {PaginationDataSource} from '../../services/api/pagination-data-source';
import {CustomEventsDataService} from '../../tables/custom-events-table/custom-events-data.service';
import {ConstantProperty} from '../../_models/constant-property';
import {ComponentType} from "../../_models/component-type";
import {CUSTOM_EVENTS_CONFIG} from "../../forms/custom-events-form/custom-events-form.component";
import {IDMap, ModelID} from '../../_typing/generic-types';
import {
    getManyRelationWithIdsFilter,
    getRelationWithIdFilter,
    getRelationWithManyIdsFilter,
} from "../../services/api/filter_utils";
import {SearchQueryOptions} from "../../services/api/search-query-options";
import {ListResponse} from "../../services/api/response-types";
import {PropByRelationshipResponse} from '../../data/constant-property-data.service';
import {SeriesDataService} from "../../services/series_data.service";
import {FormDialogService} from "../../services/form-dialog.service";
import {EventDataService} from "../../data/event-data.service";
import {ConstantLockedDict, LockDataService} from "../../services/lock-data.service";
import {
    getColIds,
    getColumnId,
    getPropertyIds,
    getComponentTypeIds,
    filterOutTempEvents,
    checkApplyNameFormat
} from '../../tables/custom-events-table/utils';
import {KeyMap} from '../../_typing/generic-types';
import {IDateTimePeriod} from "../../_typing/date-time-period";
import {TOOLTIP_SHOW_DELAY} from "../../shared/globals";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import {StringFormatType} from "../../_typing/config/string-format-type";
import {UtilsBarComponent} from "../../tables/utils-bar/utils.bar.component";
import {COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {CommonModule} from "@angular/common";
import {OverlayscrollbarsModule} from "overlayscrollbars-ngx";
import {TableUtilsService} from "../../services/table-utils.service";
import {EventComponent} from "../../_models/event-component";
import {EventTypeComponentTypeMap, EventTypeComponentTypeUniqueMap} from "../../_models/event-type-component-type-map";
import {ComponentByParentResponse} from "../../data/component-data.service";
import {RelationshipApiMappingService} from "../../data/relationship-api-mapping.service";
import {RelMappingResult} from "../../_typing/relationship-api-mapping";
import {beforeOverlayClosed} from "../../shared/utils/popup-service-helper";
import {PopupHandle} from "../../services/popup-service";
import {DateTimePickerComponent} from "../../date-time/date-time-picker/date-time-picker.component";
import {SelectManySearchBaseComponent} from "../../components/select-search-api/many/select-many-search-base.component";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {UserService} from "../../services/user.service";
import {ITileButton} from "../../_typing/tile-button";


Date.prototype['addHours'] = function (h) {
    this.setTime(this.getTime() + (h * 60 * 60 * 1000));
    return this;
};

export interface HOTDataCoords {
    startRow: number;
    startCol: number;
    endRow: number;
    endCol: number;
}

@Component({
    selector: 'event-sheet',
    templateUrl: 'event-sheet-view.component.html',
    imports: [
        UtilsBarComponent,
        MatPaginator,
        CommonModule,
        OverlayscrollbarsModule,
        COMMON_FORM_IMPORTS
    ],
    encapsulation: ViewEncapsulation.None
})
export class EventSheetViewComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('event_anchor') el: ElementRef;
    @ViewChild('utils_bar') utilsBar: ElementRef;
    @ViewChild('scroll_area') scrollArea: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: PaginationDataSource<WireEvent>;

    @Input() config: CUSTOM_EVENTS_CONFIG;
    allow_edit: boolean;
    column_list: any[];
    constant_properties: any;
    cp_name_dict: { [key: string]: string } = {};
    cp_id_dict: IDMap<ConstantProperty> = {};
    component_types_dict: IDMap<ComponentType> = {};
    equipment: any[];
    component_types: any[];
    component_type_map: any = {};
    components: WireComponent[] = [];
    componentDict: { [key: string]: WireComponent } = {};
    componentNameDict: KeyMap<ModelID> = {};
    data: any;
    dtp: IDateTimePeriod;
    event_prop_dict: { [key: string]: string[] } = {};
    event_series: any;
    etNameDict: IDMap<Partial<EventType>> = {};
    hot: HotInstance;
    non_editable_columns: any[];
    hidden_columns: any[];
    required_columns: any[] = [];
    schema: any;
    series_ids: any[];
    series_list: any;
    series_permissions: any;
    seriesList: any;
    single: boolean;
    title: string;
    users: any[];
    eventTypes: Partial<EventType>[];
    etCtDict: IDMap<IDMap<EventTypeComponentTypeUniqueMap>> = {};
    /** ----------------------------------------------------------------
     *  The list of all EventComponents from the EventComponent relationship table
     *
     *  Used to add/delete relationships in the db via SaveMany
     * ----------------------------------------------------------------*/
    eventComponents: EventComponent[];
    /** ----------------------------------------------------------------
     *  A dict for storing the EventComponent (relationships) associated with each event (row)
     * ----------------------------------------------------------------*/
    eventComponentsDict: IDMap<EventComponent[]> = {};
    /** ----------------------------------------------------------------
     *  Dict[EventId]=List of selected Component ids
     *
     *  Together with 'originalEventComponentsMap' is used to track the changes to selected components for an event to be applied via SaveMany
     * ----------------------------------------------------------------*/
    newEventComponentsMap: IDMap<ModelID[]> = {};
    /** ----------------------------------------------------------------
     *  Dict[EventId]=List of selected Component ids
     *
     *  Together with 'newEventComponentsMap' is used to track the changes to selected components for an event to be applied via SaveMany
     * ----------------------------------------------------------------*/
    originalEventComponentsMap: IDMap<ModelID[]> = {};
    /** ----------------------------------------------------------------
     *  Dict[EventId][ComponentTypeId]=List of selected Components
     *
     *  Currently selected components for each Event (row) and Component Type (column)
     *
     *  Used by select-search-component or select-many-search-component
     * ----------------------------------------------------------------*/
    eventComponentTypeMap: IDMap<IDMap<WireComponent[] | { id: ModelID }[]>> = {};
    componentUpdateCheckResults: any;
    buttons: ITileButton[];
    ec_to_save: any = [];
    ct_name_dict: KeyMap<string> = {};
    event_ct_component_map: {
        [key: string]: { [key: string]: WireComponent | { id: string | null, type: 'component' } }
    } = {};

    current_sort;
    continue_paste = true;
    @ViewChild('event_container') event_container: ElementRef;

    private readonly onDestroy = new Subject<void>();
    saving: boolean = false;
    page_size: number = 20;
    page_size_options = [10, 20, 50, 100, 200];
    events_total;
    filter_string: string = '';
    filter_warning: string;
    id_title_map: { [key: string]: string } = {};
    title_id_map: { [key: string]: string } = {};
    etCtQueryDict: KeyMap<KeyMap<any[]>> = {};
    eventTypeComponentTypes: EventTypeComponentTypeMap[];

    private rblTriggerInProgress: boolean = false;
    private hasAutoLinkingRules: boolean = false;
    locked_dict: ConstantLockedDict = {};
    row_locked_dict: KeyMap<boolean> = {};
    $page: Subscription;
    /** The page the grid is actually showing, so a failed fetch can roll the paginator back to it. */
    private lastRenderedPageIndex: number = 0;
    /**
     * The rows the grid is actually bound to, so a failed load can roll this.data back to them.
     * createTable is what binds this.data into Handsontable (hot.settings.data), and page()
     * reassigns this.data before afterPage runs - a failure between the two would otherwise
     * leave the model a page ahead of the grid. Undefined until the first page renders.
     */
    private lastRenderedData: any;
    /** events_total as of lastRenderedData; restored alongside it. */
    private lastRenderedTotal: number;
    private masterTable: HTMLElement | null = null;
    private topClone: HTMLElement | null = null;
    private scrollListener: (() => void) | null = null;

    constructor(private api: ApiService,
                private headerData: HeaderDataService,
                private handsontableGenerator: HandsontableGeneratorService,
                private dateTimePeriod: DateTimePeriodService,
                private dateInst: DateTimeInstanceService,
                private tileData: TileDataService,
                private notification: NotificationService,
                private customEventsService: CustomEventsService,
                private customEventsData: CustomEventsDataService,
                private relMapping: RelationshipApiMappingService,
                private eventDataService: EventDataService,
                private formDialogService: FormDialogService,
                private renderer: Renderer2,
                private userService: UserService,
                private seriesData: SeriesDataService,
                private lockDataService: LockDataService,
                private tableUtils: TableUtilsService) {
        this.hot = new HotInstance(['attributes.start']);
    }

    @HostListener('window:resize', ['$event']) // for window scroll events
    onResize(event) {
        this.resizeUpdate();
    }

    resizeUpdate() {
        const utilsHeight = this.utilsBar?.nativeElement?.clientHeight;
        const scrollArea = this.scrollArea?.['targetRef']?.nativeElement;
        if (scrollArea && utilsHeight) {
            this.renderer.setStyle(scrollArea, 'height', `calc(100% - ${utilsHeight}px)`);
        }
        if (this.hot.instance) {
            this.hot.instance.render();
        }
    }

    ngOnInit(): void {
        this.dateInst.dateTimePeriodRefreshed$.pipe(
            takeUntil(this.onDestroy),
            filter(() => this._isInitialized()) // Guard against race condition during initialization
        ).subscribe((dtp) => {
            this.dtp = dtp;
            let filters = this.getEventQuery();
            this.dataSource.filterBy(filters);
            this._refreshComponentQueries();
            this.createTable();
        });

        this.dateInst.dateTimePeriodChanged$.pipe(take(1), concatMap((dtp: IDateTimePeriod) => {
            if (this.config.column_widths) {
                this.handsontableGenerator.col_widths = utils.deepCopy(this.config.column_widths);
            }
            this.dtp = this.dateInst.dtp;

            this.series_list = this.seriesList;
            this.hidden_columns = this.config.hidden_columns;
            this.single = this.config.event_types.length === 1;
            this.etNameDict = {};
            this.title = 'Custom Events';

            const obs_list = [];

            const options = new SearchQueryOptions();
            options.filters = [{name: 'id', op: 'in', val: this.config.event_types.map(et => et.id)}];
            obs_list.push(this.api.event_type.searchMany(options)
                .pipe(concatMap(response => {
                    this.eventTypes = response.data;
                    const etDict: IDMap<Partial<EventType>> = {};
                    this.eventTypes.map(et => etDict[et.id] = et);
                    const cp_ids = getPropertyIds(this.config.columns);

                    return this.customEventsService.getStreamedConstantPropertiesByEventTypeIds(this.eventTypes.map(et => et.id), cp_ids)
                        .pipe(tap((prop_response: PropByRelationshipResponse) => {
                            this.cp_name_dict = {};
                            this.event_prop_dict = {};
                            this.constant_properties = prop_response.constant_properties;
                            this.cp_id_dict = prop_response.cp_dict;
                            this.constant_properties.forEach(cp => this.cp_name_dict[cp.attributes.name] = cp.id);
                            Object.keys(prop_response.props_list_dict).forEach(key => {
                                this.event_prop_dict[etDict[key].attributes.name.trim()] = prop_response.props_list_dict[key].map(id => this.cp_id_dict[id].attributes.name);
                            });
                        }));
                }))
            );

            obs_list.push(this.getEventTypeComponentTypes());

            return forkJoin(obs_list).pipe(tap(result => {
                this.non_editable_columns = [];
                this.config.columns.map(col => {
                    const col_id = getColumnId(col);
                    this.id_title_map[col_id] = col.title || (col.type === 'constant_property' ? this.cp_id_dict[col.id]?.attributes.name :
                        (col.type === 'component_type' ? this.component_types_dict[col.id]?.attributes.name : col.id));
                    if (col.disabled) {
                        this.non_editable_columns.push(col_id)
                    }
                });
            }));
        }))
            .subscribe(() => {
                this.etNameDict = {};
                this.event_series = {};
                this.series_ids = [];

                this.eventTypes.forEach((item: Partial<EventType>) => {
                    if (this.config.event_types.map(et => et.id).includes(item.id)) {
                        this.etNameDict[item.attributes.name.trim()] = item;
                        this.event_series[item.attributes.name.trim()] = item.relationships.series_list.data.map(series => series.id);
                        item.relationships.series_list.data.map(series => this.series_ids.push(series.id));
                    }
                });

                if (this.series_ids.length > 0) {
                    this.seriesData.getSeriesPermissions(this.series_ids)
                        .pipe(takeUntil(this.onDestroy))
                        .subscribe({
                            next: data => {
                                this.series_permissions = data;
                                this.allow_edit = false;
                                this.series_ids.forEach(id => {
                                    if (!this.series_permissions[id]) {
                                        this.allow_edit = true;
                                    } else if (this.series_permissions[id].includes('edit_process_data') ||
                                        this.series_permissions[id].includes('edit_todays_data')) {
                                        this.allow_edit = true;
                                    }
                                });
                                this.resetDataSource();
                            },
                            error: err => {
                                console.error('Event sheet: failed to load series permissions', err);
                                this.notification.openError(
                                    'Could not check series permissions for this sheet. It has been opened read-only. ' +
                                    'See the browser console for details.');
                                this.allow_edit = false;
                                this.resetDataSource();
                            }
                        });
                } else {
                    this.allow_edit = true;
                    this.resetDataSource();
                }
            });

        if (this.tileData?.save_content) {
            this.tileData.save_content.pipe(takeUntil(this.onDestroy)).subscribe(params => {
                this.tileData.tile.attributes.parameters = this.config;
                this.tableUtils.emitSaveTile(this.tileData);
            });
        }
        this.tileData.editing.pipe(takeUntil(this.onDestroy))
            .subscribe((value: boolean) => {
                if (this.hot.instance) {
                    let settings = this.hot.instance.getSettings();
                    settings.manualColumnResize = value;
                    this.hot.instance.updateSettings(settings, false);
                }
            })

        const eventTypeIds = this.customEventsService.getEventTypeIdsSet(this.config?.event_types);
        this.customEventsService.checkForAutoLinkingRules(eventTypeIds)
            .pipe(takeUntil(this.onDestroy))
            .subscribe({
                next: result => {
                    this.hasAutoLinkingRules = result
                    this.setButtons();
                },
                error: (e) => {
                    console.log("ERROR (checkForAutoLinkingRules): Problem fetching linking rules.", e);
                }
            });
    }

    private _updateComponentLists(components: WireComponent[]) {
        this.components = _uniqBy(this.components.concat(components), c => c.id);
        this.components.forEach(c => this.componentDict[c.id] = c);
        this.components.forEach(c => this.componentNameDict[c.attributes.name] = c.id);
    }

    private getEventComponents(): Observable<any> {
        const event_ids = this.data.map(e => e.id).filter(id => id);
        const ct_ids = this.component_types.map(ct => ct.id);
        return this.customEventsService.getEventComponents(event_ids, ct_ids)
            .pipe(tap(result => {
                this.eventComponents = result.data;
            }));
    }

    mapEventComponent(events: (WireEvent & { temp_id: ModelID })[]): void {
        // Guard against calling before initialization is complete
        if (!this._isInitialized()) {
            console.warn('EventSheetView: mapEventComponent called before initialization complete');
            return;
        }

        events.forEach(event => {
            const eventId = event.id ?? event.temp_id;
            if (!this.eventComponentTypeMap[eventId]) {
                this.eventComponentTypeMap[eventId] = {};
            }

            // Safe access to eventTypeId with null checks
            const eventTypeId = this.single
                ? (this.eventTypes?.[0]?.id ?? null)
                : event.relationships?.event_type?.data?.id;

            if (!eventTypeId) {
                console.warn(`EventSheetView: Cannot determine eventTypeId for event ${eventId}`);
                return;
            }

            this.eventComponentsDict[eventId] = this.eventComponents?.filter(ecRel => ecRel.relationships.event.data.id === eventId) || [];

            // Skip if no component types configured for this event type
            const etCtForEvent = this.etCtDict?.[eventTypeId];
            if (!etCtForEvent) {
                // This is normal if the event type has no component type columns configured
                return;
            }

            const ctIds = Object.keys(etCtForEvent);
            for (let i = 0; i < ctIds.length; i++) {
                const ctId = ctIds[i];
                if (this.eventComponentTypeMap[eventId][ctId]) {
                    continue;
                }
                this.eventComponentTypeMap[eventId][ctId] = this.components.filter(c => this.newEventComponentsMap[eventId]?.includes(c.id) && c.relationships?.component_type?.data?.id === ctId);
            }
        })
    }

    ngAfterViewInit() {
        if (this.config.event_types && this.config.event_types.length === 1) {
            this.tileData.setDefaultTitle(this.config.event_types[0].attributes.name);
        }
        this.setButtons();
    }

    createTable() {
        // const userLookup = this.handsontableGenerator.gen_lookups(this.users, item => item.attributes.name);
        const eventTypeLookup = this.handsontableGenerator.gen_lookups(this.eventTypes, item => item.attributes.name);

        this.schema = {
            id: null,
            type: 'event', //***
            attributes: {
                base_type: 'event',
                comment: null,
                start: null,
                end: null,
                created_on: null,
                changed_on: null,
                event_type_name: null,
                custom_constants: {}
            },
            relationships: {
                event_type: {data: {id: null, type: 'event_type'}},
                series_list: {data: []},
                created_by: {data: {id: null, type: 'users'}},
                changed_by: {data: {id: null, type: 'users'}},
            }
        };

        let is_readonly = col => {
            if (this.non_editable_columns) {
                return this.non_editable_columns.includes(col);
            }
            return false;
        };

        this.column_list = [
            {
                data: 'attributes.start',
                title: this.id_title_map['start'] || 'Start',
                name: 'start',
                width: 160,
                defaultDate: this.dtp.start,
                allowEmpty: false,
                readOnly: is_readonly('start'),
                renderer: 'hot_date_renderer',
                editor: false,
                type: 'date',
                custom_type: 'date'
            }
        ];
        if (getColIds(this.config.columns).includes('end')) {
            this.column_list.push({
                data: 'attributes.end',
                type: 'date',
                title: this.id_title_map['end'] || 'End',
                name: 'end',
                width: 160,
                defaultDate: this.dtp.end,
                allowEmpty: false,
                readOnly: is_readonly('end'),
                renderer: 'hot_date_renderer',
                editor: false,
                custom_type: 'date'
            });

            this.column_list.push({
                data: (row, value) => {
                    if (row && row['attributes']) {
                        if (row.attributes.start && row.attributes.end) {
                            let rHours, rMin, rSec;
                            if (row.attributes.start < row.attributes.end) {
                                //@ts-ignore
                                const dur_ms = (new Date(row.attributes.end)) - (new Date(row.attributes.start));

                                const hours = Math.floor(dur_ms / 3600000);
                                const minutes = Math.floor(dur_ms % 3600000 / 60000);
                                const seconds = dur_ms / 1000 - hours * 3600 - minutes * 60;
                                rHours = (hours >= 10) ? hours : "0" + hours;
                                rMin = (minutes >= 10) ? minutes : "0" + minutes;
                                rSec = (seconds >= 10) ? seconds : "0" + seconds;
                            } else {
                                rHours = '00';
                                rMin = '00';
                                rSec = '00';
                            }

                            return rHours + ':' + rMin + ':' + rSec;
                        }
                    }
                },
                title: this.id_title_map['duration'] || 'Duration',
                name: 'duration',
                readOnly: true
            });
        }

        if (this.single && this.eventTypes?.length > 0) {
            this.schema.attributes.event_type_name = this.config.event_types[0].attributes.name;
            this.schema.relationships.event_type.data.id = this.eventTypes[0].id;
        }

        this.column_list.push({
            data: this.handsontableGenerator.genLookupDataSource(eventTypeLookup, 'event_type'),
            title: this.id_title_map['type'] || 'Type',
            name: 'type',
            type: 'autocomplete',
            source: eventTypeLookup.source,
            strict: true
        });

        this.component_types.forEach(ct => {
            let new_column =
                {
                    data: (row) => {
                        if (!row) return;
                        const eventId = row.id ?? row.temp_id;
                        return this.eventComponentTypeMap?.[eventId]?.[ct.id]?.map(v => v.attributes.name)
                    },
                    title: this.id_title_map[ct.id] || ct.attributes.name,
                    name: ct.id,
                    renderer: 'infinite_scroller',
                    readOnly: is_readonly(ct.attributes.name)
                };
            this.column_list.push(new_column);
        });

        this.constant_properties.forEach(item => {
            //TODO add date as well
            this.schema.attributes.custom_constants[item.attributes.name.trim()] = null;
            const data_type_map = {
                'string': 'text',
                'float': 'numeric',
                'datetime': 'date',
                'calculation': 'numeric'
            };
            let new_column;
            if (item.attributes.data_type === 'float') {
                new_column = {
                    data: 'attributes.custom_constants.' + item.attributes.name,
                    title: this.id_title_map[item.id] || item.attributes.name,
                    name: item.id,
                    type: data_type_map[item.attributes.data_type],
                    format: "0.000"
                };
            } else {
                new_column = {
                    data: 'attributes.custom_constants.' + item.attributes.name,
                    title: this.id_title_map[item.id] || item.attributes.name,
                    name: item.id,
                    type: data_type_map[item.attributes.data_type],
                };
                if (new_column.type === 'date') {
                    new_column.defaultDate = this.dtp.start;
                    new_column.renderer = 'hot_date_renderer';
                    editor: false;
                    new_column.custom_type = 'date';
                }
            }
            new_column.readOnly = is_readonly(item.id) || item.attributes.is_calculation;
            if (item.attributes.is_drop_down_list) {
                new_column.type = 'autocomplete';
                new_column.source = item.attributes.json;
                new_column.strict = true;
            }
            this.column_list.push(new_column);
        });

        this.column_list = this.column_list.concat([
            {
                data: 'attributes.comment',
                type: 'text',
                title: this.id_title_map['comment'] || 'Comment',
                name: 'comment',
                readOnly: is_readonly('comment'),
                className: "htLeft"
            },
            {
                data: 'attributes.changed_by_name',
                readOnly: true,
                title: this.id_title_map['changed_by'] || 'Changed By',
                name: 'changed_by',
            },
            {
                data: 'attributes.changed_on',
                readOnly: true,
                title: this.id_title_map['changed_on'] || 'Changed On',
                name: 'changed_on',
                type: 'date',
                renderer: 'date_formatter'
            }
        ]);

        this.column_list.forEach(col => {
            this.id_title_map[col.name] = col.title;
            this.title_id_map[col.title] = col.name;
        })

        this._setColumnWidths();

        this.required_columns = [];
        if (!this.single) {
            this.required_columns.push('type');
        }

        if (this.config.columns && this.config.columns.length >= 1) {
            this.column_list = utils.mapOrder(utils.deepCopy(this.column_list), getColIds(this.config.columns), 'name');
            this.column_list = this.column_list.filter(col => {
                return (getColIds(this.config.columns).includes(col.name) || this.required_columns.includes(col.name));
            });
        }

        this.hot = this.handsontableGenerator.generateTable(this.api.event, this.schema, this.column_list, this.hot /*should prevent new
         HotInstances from being created the whole time*/, this.extraAfterChange.bind(this), null, this.row_locked_dict);
        this.hot.settings.rowHeaders = false;
        this.hot.settings.columnSorting = true;
        this.hot.settings.readOnly = !this.allow_edit;
        this.hot.settings.manualColumnResize = true;
        this.hot.settings.minSpareRows = 0;
        this.hot.settings.required_keys = this.required_columns;
        this.setSort();

        this.hot.settings.cells = (row, col, prop) => {
            if (this.hot.instance) {
                const column = this.hot.instance.getColHeader(col).toString();
                const ct = this.component_types.find(component_type => component_type.id === this.title_id_map[column]);
                const colIndex = this.hot.instance.getColHeader().indexOf(this.id_title_map['type']);
                const eventTypeName = this.hot.instance.getDataAtCell(row, colIndex);
                const eventTypeId = this.etNameDict?.[eventTypeName]?.id;

                if (ct && !this.single) {
                    if (eventTypeId && this.etCtDict[eventTypeId] && Object.keys(this.etCtDict[eventTypeId]).includes(ct.id)) {
                        return {readOnly: is_readonly(ct.attributes.name)}
                    } else {
                        return {readOnly: true};
                    }
                }
                let key = prop?.toString().replace("attributes.", "").replace("custom_constants.", "");
                let id = this.hot.instance.getDataAtRowProp(row, 'id');
                if (!this.single && prop.toString().indexOf('custom_constants') > -1) {
                    let cellProperties = {readOnly: true};
                    let custom_constant = prop.toString().replace('attributes.custom_constants.', '');
                    if (eventTypeName && this.event_prop_dict[eventTypeName].includes(custom_constant) && is_readonly(this.cp_name_dict[custom_constant]) === false
                        && ((id && key && this.locked_dict[id]?.[key] !== true) || !id)) {
                        cellProperties.readOnly = false;
                    }
                    return cellProperties;
                }
                if (!this.single && this.hot.instance.getColHeader(col) === 'Type') {
                    let cellProperties = {readOnly: this.single ? is_readonly('type') : false};
                    const dataItem = this.hot.instance.getSourceDataAtRow(row);
                    const isExistingItem = dataItem && dataItem['id'];
                    if (!this.single && isExistingItem) {
                        cellProperties.readOnly = true;
                    }
                    return cellProperties;
                }

                if (id && key && this.locked_dict[id]?.[key] === true) {
                    let cellProperties = {readOnly: true};
                    return cellProperties;
                }
            }
        };
        this.hot.settings.afterColumnResize = (colIndex, width) => {
            this.column_list[colIndex].width = width;
            if (this.config.columns[colIndex]?.format) {
                this.config.columns[colIndex].format = Object.assign(this.config.columns[colIndex].format, {width: width})
            }
        }
        this.setupInfiniteScroll();
        this.addBeforeChangeHook();

        if (!this.config.allow_delete) {
            this.hot.settings.contextMenu = {
                callback: null,
                items: {"not_allowed": {name: 'Delete not allowed'}}
            };
        }
        this.hot.ready = true;
        this.hot.settings.data = this.data;
        this.hot.settings.width = '100%';
        this.hot.settings.height = '100%';

        const element = this.el.nativeElement;
        if (this.hot.instance) {
            this.hot.instance.updateSettings(this.hot.settings, false);
        } else {
            this.hot.instance = new Handsontable(element, this.hot.settings);
        }
        if (this.current_sort) {
            this.hot.instance.getPlugin('columnSorting').sort(this.current_sort);
        }
        if (this.events_total < 1) {
            this.insert();
        }

        this.addScrollEventHook();
    }

    extraAfterChange(changes: any[], source) {
        if (!changes || source === 'loadData') return;

        let events = [];
        changes.forEach(change => {
            const [row, prop, oldValue, newValue] = change;
            const colIndex = this.hot.instance.propToCol(prop)
            const column = this.hot.instance.getColHeader(colIndex).toString();
            if (column === 'Type') {
                const oldId = oldValue?.data?.id;
                const newId = newValue?.data?.id;
                const cellMeta = this.hot.instance.getCellMeta(row, colIndex)
                const event = this.data[cellMeta['row']];
                if (newId && newId !== oldId && event) {
                    events.push(event);
                }
            }
        });
        if (events.length) {
            this.mapEventComponent(events)
        }
    }

    private _setColumnWidths(): void {
        const colsWithWidths = this.config.columns.filter(col => col.format?.width);
        this.column_list.forEach(col => {
            const i = colsWithWidths.findIndex(c => c.id === col.name);
            if (i > -1) {
                col.width = colsWithWidths[i].format.width;
            }
        });
    }

    addBeforeChangeHook() {
        this.hot.settings.beforeChange = (changes: any[], source) => {
            if (!changes || source === 'loadData') return;
            changes.forEach(change => {
                const [row, prop, oldValue, newValue] = change;
                let custom_constant = prop.toString().replace('attributes.custom_constants.', '');
                const cpId: ModelID = this.cp_name_dict[custom_constant];
                if (!cpId || !this.cp_id_dict[cpId]?.attributes) return;
                const cp = this.cp_id_dict[cpId];
                if (checkApplyNameFormat(cp)) {
                    switch (cp.attributes.name_format) {
                        case StringFormatType.UPPER:
                            change[3] = String(newValue).toUpperCase();
                            break;
                        case StringFormatType.LOWER:
                            change[3] = String(newValue).toLowerCase();
                            break;
                        default:
                            break;
                    }
                }
            })
        }
    }

    addScrollEventHook() {
        this.masterTable = document.querySelector('.ht_master .wtHolder');
        this.topClone = document.querySelector('.ht_clone_top .wtHolder');

        if (this.masterTable && this.topClone) {
            this.scrollListener = () => {
                if (this.topClone) {
                    this.topClone.scrollLeft = this.masterTable!.scrollLeft;
                }
            };

            this.masterTable.addEventListener('scroll', this.scrollListener);
        }
    }

    getEventQuery(): any[] {
        let filters: any[] = [];
        const ev_query = [this.eventDataService.generateEventDateFilter(this.dtp.start, this.dtp.end),
            getRelationWithManyIdsFilter('event_type', this.config.event_types.map(et => et.id))];

        return ev_query;
    }

    updateSearchFilter() {
        let filters = this.getEventQuery();
        const string_filters = {or: []};
        ['comment'].forEach(att => {
            string_filters.or.push({op: 'ilike', name: att, val: '%' + this.filter_string + '%'});
        });

        string_filters.or = string_filters.or.concat(this.customEventsData.generateConstantPropertiesSearchFilter(this.constant_properties.map(cp => cp.id), this.cp_name_dict, this.filter_string));
        string_filters.or = string_filters.or.concat(this.customEventsData.generateComponentSearchFilter(this.component_types.map(cp => cp.id), this.filter_string));

        filters.push(string_filters);
        this.dataSource.filterBy(filters);
    }

    setSort() {
        const allowed = ['start', 'end', 'comment'];
        this.hot.settings.beforeColumnSort = (currentSort, destinationSort) => {
            let sort;
            this.filter_warning = '';
            if (destinationSort?.length) {
                const col_index = destinationSort[0]?.column;
                const col = this.hot.instance.getColHeader(col_index) as string;
                if (!col) {
                    return;
                }
                sort = this.title_id_map[col].toString().toLowerCase().replace('*', '');
                if (!allowed.includes(sort)) {
                    this.current_sort = destinationSort;
                    this.filter_warning = "Only the current page has been sorted.";
                    return true;
                }
            }

            this.current_sort = null;
            let sortChange = new MatSort();
            sortChange.active = sort;
            sortChange.direction = destinationSort[0]?.sortOrder;
            this.dataSource.sortBy(sortChange);
            // return false; // If not using this causes problems/confusion we'll need to manually keep track of the current sort.
        };

    }

    setupInfiniteScroll() {
        this.hot.settings.beforeKeyDown = (event) => {
            //For backspace and delete
            if (![8, 46].includes(event.keyCode)) {
                return;
            }
            const range = this.hot.instance.getSelectedRange()[0];
            let coords = this.getCoordsFromAutofill(range.from, range.to);
            // Fill empty array of array (mimic pasted data)
            const pasted = Array.from({length: coords.endRow - coords.startRow + 1}, () =>
                Array.from({length: coords.endCol - coords.startCol + 1}, () => null));
            this.beforePaste(pasted, coords);
        }

        this.hot.settings.beforeAutofill = (startAt, endAt, sourceData, direction) => {
            let coords = this.getCoordsFromAutofill(startAt, endAt);
            let pasted = [];
            let row = [];

            // Fill array from single row (mimic pasted data)
            sourceData[0].map(col => row.push(col))
            for (let i = 0; i <= coords.endRow - coords.startRow; i++) {
                pasted.push(row)
            }
            this.beforePaste(pasted, coords);
            if (this.continue_paste) {
                this.getByName(pasted, coords);
            }
        }

        this.hot.settings.beforePaste = (pasted, config) => {
            this.beforePaste(pasted, config[0]);
        }

        this.hot.settings.afterPaste = (pasted, config) => {
            if (!this.continue_paste) {
            } else {
                this.getByName(pasted, config[0]);
            }
        };

        this.hot.settings.afterOnCellMouseDown = (event, coords) => {
            this.setCustomRendererCallbacks(event, coords);
        };
    }

    private getCoordsFromAutofill(selectionData, sourceRange): HOTDataCoords {
        return {
            startRow: selectionData.row,
            startCol: selectionData.col,
            endRow: sourceRange.row,
            endCol: sourceRange.col
        };
    }

    private beforePaste(pasted, coords: HOTDataCoords) {
        // Copy the original data and change_ids in case of a rollback
        const data_pre_paste = utils.deepCopy(this.data);
        const change_ids = utils.deepCopy(this.hot.change_ids);
        this.componentUpdateCheckResults = null;

        const rows = this.getPastedComponentTypeRows(pasted, coords);
        // If continue_paste then no component changes were found
        if (this.continue_paste) {
            console.log("No overwrite changes found",);
            return;
        }
        let $check: Observable<boolean>;
        if (!this.config.allow_delete) {
            this.notification.openError("Deleting components from events is not allowed.", 10000);
            $check = of(false).pipe(delay(100));
        } else if (rows === null) {
            $check = of(false).pipe(delay(100));
        } else {
            $check = this.showEventComponentDeleteCheck(rows, pasted);
        }

        $check.pipe(take(1)).subscribe((continue_paste: boolean) => {
            if (continue_paste) {
                // Adjust the config coords manually to include endRow and endCol boundaries, then call after paste function (getByName)
                const endRow = coords.startRow + pasted.length - 1;
                const endCol = coords.startCol + pasted[0].length - 1;
                const totalCols = this.hot.instance.countCols();
                coords = Object.assign(coords, {endCol: endCol > totalCols ? totalCols : endCol})

                this.getByName(pasted, coords, true);
            } else {
                this.resetDataBeforePaste(data_pre_paste, change_ids)
            }
        });
    }

    private resetDataBeforePaste(data_pre_paste, change_ids) {
        this.data = utils.deepCopy(data_pre_paste);
        this.hot.instance.loadData(this.data);
        const current_ids = this.hot.change_ids;
        this.hot.change_ids = _difference(current_ids, change_ids);
    }

    private getPastedComponentTypeRows(pasted, config: HOTDataCoords) {
        this.continue_paste = true;
        let i = utils.deepCopy(config.startCol);
        const p_cols = pasted[0].length + config.startCol;
        const p_rows = pasted.length + config.startRow;
        const ct_ids = getComponentTypeIds(this.config.columns);
        let rows = [];
        for (let c = config.startCol; c < p_cols; c++) {
            const column = this.hot.instance.getColHeader(c).toString();

            if (ct_ids.includes(this.title_id_map[column])) {
                for (let r = config.startRow; r < p_rows; r++) {
                    let prop_data = {};
                    const event_type_id = this.single ? (this.eventTypes?.[0]?.id ?? null) : this.hot.instance.getDataAtRowProp(r, 'relationships.event_type')?.data?.id;

                    if (!event_type_id) {
                        this.notification.openError(`Event type needs to be set before pasting values.`);
                        this.continue_paste = false;
                        return null;
                    }

                    this.constant_properties.forEach(cp => {
                        prop_data[cp.id] = this.hot.instance.getDataAtRowProp(r, 'attributes.custom_constants.' + cp.attributes.name)
                    });

                    //TODO get data from original list - don't bother about data in cells that haven't been saved
                    const current_val = this.hot.instance.getDataAtCell(r, c); //component name string array
                    const pasted_val = pasted[r - config.startRow]?.[c - config.startCol];
                    const pastedValues = Array.isArray(pasted_val) ? pasted_val : pasted_val?.split(',').map(v => v.trim());
                    const componentTypeId = this.title_id_map[column];
                    const isSingle = this.etCtDict?.[event_type_id]?.[componentTypeId]?.hasOneComponent;

                    if (isSingle && pastedValues?.length > 1) {
                        this.notification.openError(`${column} can only accept single values and you tried to paste in multiple values: ${pastedValues}`);
                        this.continue_paste = false;
                        return null;
                    }
                    let row = {
                        event_type_id: event_type_id,
                        prop_data: prop_data,
                        row: r,
                        col: c,
                        component_type_id: componentTypeId,
                        component_type_name: column,
                        current_value: current_val,
                        pasted_value: pastedValues,
                        include: false,
                        replace: false,
                        is_single: isSingle
                    };
                    rows.push(row);

                    if (!pastedValues || (current_val?.length && !current_val.every(c => pasted_val.includes(c)))) {
                        this.continue_paste = false;
                    }
                }
            }
        }
        return rows;
    }

    showEventComponentDeleteCheck(rows, pasted): Observable<boolean> {
        const data = {
            et_ct_dict: this.etCtDict,
            constant_properties: getPropertyIds(this.config.columns),
            columns: this.config.columns,
            rows: rows
        }
        return this.formDialogService.eventComponentDeleteCheck(data).afterClosed().pipe(map(result => {
            this.componentUpdateCheckResults = result;
            console.log("result of check ", result);
            if (result === false) {
                return false;
            }
            return true;
        }));
    }

    setCustomRendererCallbacks($event, coords) {
        if (this.hot.instance.getCellMeta(coords.row, coords.col)?.readOnly) {
            return;
        }
        const column = this.hot.instance.getColHeader(coords.col).toString();
        const data_type = this.column_list[coords.col].custom_type;

        let overlayHandle: PopupHandle<DateTimePickerComponent | SelectManySearchBaseComponent | SelectSearchComponentComponent>;
        if (data_type === 'date') {
            overlayHandle = this.handsontableGenerator.genDatePickerCallback($event, coords, this.hot, this.data, this.dtp);
        } else {
            const ct = this.component_types.find(component_type => component_type.id === this.title_id_map[column]);
            if (!ct) {
                return;
            }
            //TODO make sure eventTypeId is set - disable custom renderers not relevant to current event based on event_type
            const eventTypeId = this.single ? (this.eventTypes?.[0]?.id ?? null) : this.hot.instance.getDataAtRowProp(coords.row, 'relationships.event_type')?.data?.id;
            const open_custom = $event.target.classList.contains('hot-infinite-scroll-click');
            if (open_custom) {
                const isSingle = this.etCtDict?.[eventTypeId]?.[ct.id]?.hasOneComponent;

                const actualRowId = this._eventIdFromCell(coords.row, coords.col);
                let selectedValues = this.eventComponentTypeMap?.[actualRowId]?.[ct.id];

                const selectionChanged = this._updateComponentRelationship(actualRowId, ct.id, coords.row, coords.col, isSingle).bind(this);

                overlayHandle = this.handsontableGenerator.openScroller(this.hot.instance, null, this.etCtQueryDict?.[eventTypeId]?.[ct.id],
                    $event, coords, selectionChanged, !isSingle, selectedValues);
            }
        }

        if (overlayHandle) {
            beforeOverlayClosed(overlayHandle.overlayRef).subscribe(() => {
                const gridsterElement = document.querySelector('gridster');
                if (gridsterElement) {
                    gridsterElement.removeAttribute('aria-hidden');
                }
            })

            return false;
        }
    }

    private _eventIdFromCell(row: number, col: number): ModelID {
        const cellMeta = this.hot.instance.getCellMeta(row, col)
        return this.data[cellMeta['row']]?.id ?? this.data[cellMeta['row']]?.temp_id;
    }

    private _updateComponentRelationship(eventId: ModelID, componentTypeId: ModelID, row, col, single = true) {
        return ($event) => {
            const value = single ? [$event.value] : $event;

            if (single) {
                this.eventComponentTypeMap[eventId][componentTypeId] = value;
            } else {
                this.eventComponentTypeMap[eventId][componentTypeId] = this.eventComponentTypeMap[eventId][componentTypeId]?.filter(c => value.findIndex(e => e.id === c.id) > -1);
            }

            this._updateNewEventComponentsMap(eventId);
            this._updateComponentLists(value);

            this.hot.instance.setDataAtCell(row, col, this.eventComponentTypeMap[eventId][componentTypeId]);
        }
    }

    private _updateNewEventComponentsMap(eventId: ModelID): void {
        if (!this.eventComponentTypeMap[eventId]) {
            this.newEventComponentsMap[eventId] = [];
            return;
        }

        this.newEventComponentsMap[eventId] = Object.keys(this.eventComponentTypeMap[eventId])
            .reduce((acc, ctId) => {
                const components = this.eventComponentTypeMap[eventId][ctId];
                return acc.concat(components || []);
            }, [])
            .map(c => c?.id)
            .filter(id => id != null);
    }

    getByName(pasted, config: HOTDataCoords, afterCheck = false) {
        const $obs = [];

        this.component_types.forEach(ct => {
            console.log("", ct.attributes.name);
            const from_pasted = this.handsontableGenerator.getMultiFiltersFromPasted(
                pasted, config, this.hot, Object.keys(this.componentNameDict) || [], ct.id, [this.id_title_map[ct.id]]);

            if (!from_pasted?.options) {
                console.log("Components already loaded",);
                this._updateItemFromPaste(from_pasted.paste_map, ct.id, true);
                return;
            }
            $obs.push(this.api.component.searchMany(from_pasted.options).pipe(
                tap(result => {
                    this._updateComponentLists(result.data);
                    if (!afterCheck) {
                        console.log("No check was needed for ", ct.attributes.name);
                        this._updateItemFromPaste(from_pasted.paste_map, ct.id);
                        return;
                    }
                    console.log("Check completed for ", ct.attributes.name);
                    this.component_type_map[ct.id] = _uniq(this.component_type_map[ct.id].concat(result.data));
                    this._updateItemFromPaste(from_pasted.paste_map, ct.id, true);
                })));
        });
        const ids = this.hot.change_ids;
        if ($obs.length < 1) {
            return;
        }

        this.saving = true;
        forkJoin($obs).pipe(first(), takeUntil(this.onDestroy)).subscribe(() => {
            this.saving = false;
            this.hot.change_ids = ids;
            this.hot.instance.updateSettings(this.hot.settings, false);
            this.saving = false;
        });
    }

    private _updateItemFromPaste(pasteMap, componentTypeId, something?) {
        if (!Object.keys(pasteMap)?.length) return;
        for (const key of Object.keys(pasteMap)) {
            const row = Number(key);
            const item = pasteMap[row];
            const col = item[0];
            const componentName = item[1];
            const componentNames = Array.isArray(componentName) ? componentName : componentName?.split(',').map(v => v.trim());

            let eventId: ModelID = this._eventIdFromCell(row, col);
            const eventTypeId = this.hot.instance.getDataAtRowProp(row, 'relationships.event_type')?.data?.id;

            let components = componentNames.map(name => this.componentDict[this.componentNameDict[name]]);
            components = components.filter(component => component);

            const check = !!this.componentUpdateCheckResults;
            const checkResult = this.componentUpdateCheckResults?.filter(r => {
                return r.component_type_id === componentTypeId && r.row === row && r.col === col;
            });

            if (this.data[row]?.id === null && !this.data[row]?.temp_id) {
                eventId = guid();
                this.data[row].temp_id = eventId;
                this.mapEventComponent([this.data[row]]);
            }
            if (!check || checkResult?.[0]?.replace) {
                console.log("No check was run or replace was chosen for " + eventId + " and " + this.component_types_dict[componentTypeId]);
                this.eventComponentTypeMap[eventId][componentTypeId] = components ? components : [];
            } else if (checkResult?.[0]?.include) {
                console.log("User chose to add to selection for " + eventId + " and " + this.component_types_dict[componentTypeId]);
                this.eventComponentTypeMap[eventId][componentTypeId] = _uniqBy(this.eventComponentTypeMap[eventId][componentTypeId].concat(components), c => c.id);
            } else if (check && !checkResult?.length) {
                //Wrong componentTypeId pasted
                console.log("Some type of issue for " + eventId + " and " + this.component_types_dict[componentTypeId]);
            }
            this._updateNewEventComponentsMap(eventId);
            this.hot.instance.setDataAtCell(row, col, this.eventComponentTypeMap[eventId][componentTypeId]);
        }
        console.log("eventComponentTypeMap", this.eventComponentTypeMap);
    }

    save() {
        // delete new items that are empty from the change (new_rows) array
        this.hot.new_rows = this.handsontableGenerator.checkEmptyRows(this.hot);
        const sourceData = this.hot.instance.getSourceData();
        let validate: boolean = true;

        sourceData.forEach(item => {
            // make the current time the default for start time the 'Start' column was not included in the table
            if (item?.attributes && !item.attributes.start && !getColIds(this.config.columns).includes('start')) {
                item.attributes.start = new Date();
            }
            // Null-check on start & end time here since `new Date(null)` produces '1970-01-01'
            if (item?.attributes && item.attributes.start) {
                item.attributes.start = new Date(item.attributes.start).toISOString();
            }
            if (item?.attributes && item.attributes.end) {
                item.attributes.end = new Date(item.attributes.end).toISOString();
            }

            if (item && item['attributes'] && this.etNameDict[item.attributes.event_type_name] != null) {
                const event_type = this.etNameDict[item.attributes.event_type_name];
                item.relationships.event_type.data = {id: event_type.id, type: 'event_type'};
                if (item.relationships['series_list']) {
                    item.relationships.series_list.data = event_type.relationships.series_list.data.map(item2 => ({
                        'id': item2.id,
                        'type': 'series'
                    }));
                    this.schema.relationships.series_list.data = event_type.relationships.series_list.data.map(item2 => ({
                        'id': null,
                        'type': 'series'
                    }));
                }
            }
            if (!this.customEventsService.checkStartAndEndDates(item, 'start', 'end', this.hot.change_ids)) {
                validate = false;
                return false;
            }
            this.validateRelationships(item);
        });

        if (!validate) {
            return false;
        }

        let results = this.hot.save();
        this.saving = true;
        forkJoin(results.deferreds).pipe(
            concatMap(() => {
                this.data = results.data;
                let $obs = [];
                this.data.forEach(event => {
                    $obs.push(this.getEventComponentObservable(results, event));

                })
                if (!$obs.length) {
                    return of(results);
                }

                return forkJoin($obs)
                    .pipe(
                        tap((perEvent: { event_id: ModelID, relationshipFailures: any[] }[]) => {
                            // hot.save() has already cleared successful event ids from change_ids
                            // via its internal promise handler. Re-add any event whose
                            // component-link batch had partial failures so a re-Save retries them.
                            perEvent.forEach(r => {
                                if (r?.relationshipFailures?.length
                                    && !this.hot.change_ids.includes(r.event_id)) {
                                    this.hot.change_ids.push(r.event_id);
                                }
                            });
                        }),
                        catchError(error => {
                            this.notification.openError(`Error updating linked components: ${error}`);
                            console.log('ERROR: EventSheetView (save), error updating linked components:', error);
                            return of(error);
                        })
                    )
            }),
            catchError(e => {
                console.log('ERROR: EventSheetView (save): ' + e, this.data);
                return of(e);
            }),
            finalize(() => {
                this.saving = false;
                this.hot.instance.render();
            })
        ).subscribe();
    }

    getEventComponentObservable(result, event): Observable<any> {
        if (event.temp_id && event.temp_id !== event.id) {
            this.newEventComponentsMap[event.id] = this.newEventComponentsMap[event.temp_id];
            this.originalEventComponentsMap[event.id] = this.originalEventComponentsMap[event.temp_id];
            this.eventComponentTypeMap[event.id] = utils.deepCopy(this.eventComponentTypeMap[event.temp_id]);

            delete this.originalEventComponentsMap[event.temp_id];
            delete this.newEventComponentsMap[event.temp_id];
            delete this.eventComponentTypeMap[event.temp_id];
            delete event.temp_id;
        }

        if (this.componentsUnchanged(this.originalEventComponentsMap[event.id], this.newEventComponentsMap[event.id])) {
            return of({event_id: event.id, relationshipFailures: []});
        }

        return this.relMapping.saveMany('event_component', 'event', event.id, 'component',
            this.newEventComponentsMap[event.id]?.filter(id => id).map(i => {
                return {id: i};
            }),
            this.originalEventComponentsMap[event.id]?.filter(id => id).map(i => {
                return {id: i};
            }),
            this.eventComponentsDict[event.id])
            .pipe(
                tap((res: RelMappingResult) => {
                    if (res.failures.length > 0) {
                        this.notification.openError(
                            `${res.failures.length} component link(s) failed to save. Re-saving will retry them.`);
                    }
                }),
                concatMap((res: RelMappingResult) =>
                    this.getEventComponents().pipe(map(() => {
                        this.mapEventComponent([event]);
                        // Reconcile diff baseline against refreshed server truth so failed items
                        // remain in the next diff and can be retried by hitting Save again.
                        this.originalEventComponentsMap[event.id] = (this.eventComponentsDict[event.id] || [])
                            .map(link => link.relationships.component.data.id);
                        return {event_id: event.id, relationshipFailures: res.failures};
                    }))
                )
            );
    }

    componentsUnchanged(a: ModelID[], b: ModelID[]): boolean {
        return _difference(a, b).length === 0 && _difference(b, a).length === 0
    }

    validateRelationships(item) {
        // Don't bother with items that aren't being saved/updated
        if (item.id !== null && !this.hot.change_ids.includes(item.id)) {
            return;
        }
        Object.keys(item.relationships).forEach(rel => {
            if (item.relationships[rel].data?.id === '' ||
                (item.relationships[rel].data && item.relationships[rel].data.id === undefined)) {
                item.relationships[rel].data.id = null;
            }
        });
    }

    download() {
        this.hot.download();
    }

    insert(amount = 1) {
        if (this.hot.instance) {
            this.hot.instance.alter('insert_row', this.hot.instance.getData().length, amount);
        }
        this.data = this.dataSource.data;
        this.data.map(item => {
            if (item.id === null) {
                item.temp_id = utils.guid();
            }
            this.mapEventComponent([item]);
        });
    }

    buildHeader() {
        this.headerData.title = 'Custom Events';
        if (this.headerData.component_buttons_loaded === false) {
            this.headerData.buttons = this.headerData.buttons.concat([
                {name: 'Save', func: this.save.bind(this), class: 'icon-save'},
                {name: 'Download', func: this.download.bind(this), class: 'icon-download'}
            ]);
            this.headerData.component_buttons_loaded = true;
        }
    }

    runAutomaticLinkingForConfiguredEventTypes(): void {
        if (this.rblTriggerInProgress) {
            return;
        }
        const eventTypeIds = this.customEventsService.getEventTypeIdsSet(this.config?.event_types);
        if (!eventTypeIds?.length) {
            this.notification.openError("No event types configured for this table.");
            return;
        }

        this.rblTriggerInProgress = true;
        this.setButtons();
        this.customEventsService.runAutomaticLinkingForConfiguredEventTypes(eventTypeIds).pipe(
            takeUntil(this.onDestroy),
            finalize(() => {
                this.rblTriggerInProgress = false;
                this.setButtons();
            })
        ).subscribe();

    }

    setButtons() {
        this.buttons = [{
            name: 'Save',
            func: () => this.save(),
            class: 'fa fa-save',
            HoverOverHint: 'Save'
        }, {
            name: 'Download',
            func: () => this.download(),
            class: 'fa fa-download',
            HoverOverHint: 'Download'
        }, {
            name: 'Insert',
            func: () => this.insert(),
            class: 'fa fa-plus',
            HoverOverHint: 'Add empty row'
        }, {
            name: this.rblTriggerInProgress ? 'Queueing Auto Linking...' : 'Run Auto Linking',
            func: () => this.runAutomaticLinkingForConfiguredEventTypes(),
            class: 'fa small fa-link hide-xs',
            HoverOverHint: 'Queue rule-based linking for configured event type rules',
            disabled: this.rblTriggerInProgress
                || !(this.config?.event_types?.length > 0)
                || !this.userService.canRunAutoLinking()
                || !this.hasAutoLinkingRules
        }];
        this.tileData.buttonsChanged.next(this.buttons);
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();

        if (this.masterTable && this.scrollListener) {
            this.masterTable.removeEventListener('scroll', this.scrollListener);
        }
    }

    getEventTypeComponentTypes(): Observable<any> {
        this.etCtDict = {};
        const ctIds = getComponentTypeIds(this.config.columns);
        const eventTypeIds = this.config.event_types.map(et => et.id);
        return this.customEventsService.getEventTypeComponentTypeData(eventTypeIds, ctIds, this.config.component_type_date_filters, this.dtp)
            .pipe(take(1), tap(result => {
                ({
                    component_types: this.component_types,
                    component_types_dict: this.component_types_dict,
                    etCtDict: this.etCtDict,
                    etCtQueryDict: this.etCtQueryDict,
                    eventTypeComponentTypeData: this.eventTypeComponentTypes
                } = result);
            }));
    }

    getLinkedComponents(events): Observable<any> {
        if (!events || events.length < 1) {
            return of(null);
        }
        const event_ids = filterOutTempEvents(this.data, this.hot.change_ids)?.map(e => e.id);
        const ct_ids = this.component_types.map(ct => ct.id);
        const $ec = this.getEventComponents();
        const $ec_dict = this.customEventsService.getComponentsByEvent(event_ids, ct_ids)
            .pipe(
                tap((result: ComponentByParentResponse) => {
                    this._updateComponentLists(result.components);
                    this.newEventComponentsMap = Object.assign(this.newEventComponentsMap, result.component_list_dict || {});
                })
            );
        return forkJoin([$ec_dict, $ec]).pipe(tap(() => {
            this.mapEventComponent(this.data);
            this.originalEventComponentsMap = deepCopy(this.newEventComponentsMap);
        }));
    }

    resetDataSource() {
        const initialQuery = new SearchQueryOptions();
        initialQuery.page_number = 1;
        initialQuery.sort = 'start';
        this.paginator.pageSize = this.config.page_size ? this.config.page_size : this.page_size;
        this.paginator.pageIndex = 0;
        initialQuery.filters = this.getEventQuery();
        this.dataSource = new PaginationDataSource<WireEvent>(
            (query) => this.page(query),
            initialQuery,
            this.paginator,
            this.sort
        );
        this.$page = utils.refreshSubscription(this.$page);
        this.$page = this.dataSource.$page.pipe(
            // Errors are caught per page, INSIDE the switchMap, never on the outer pipe:
            // an outer catchError replaces the whole stream with its fallback, so the
            // subscription completes and every later paginator/sort/filterBy query is
            // dropped - one transient failure would freeze the sheet until a reload.
            // resetDataSource is only ever called once, so nothing would resubscribe.
            // defer() is what makes that containment complete: afterPage dereferences
            // this.data before it returns anything, and a synchronous throw from the
            // projection function bypasses a catchError piped onto its result.
            switchMap(response => defer(() => this.afterPage(response)).pipe(
                catchError(err => this.handleLoadError(err))
            )),
            takeUntil(this.onDestroy))
            .subscribe((response: ListResponse<WireEvent>) => {
                if (!response?.meta) {
                    return;
                }
                this.hot['new_rows'] = [];
                this.paginator.length = response.meta.count;
                this.lastRenderedPageIndex = this.paginator.pageIndex;
                this.lastRenderedData = this.data;
                this.lastRenderedTotal = this.events_total;
                this.saving = false;
                this.createTable();
                this.resizeUpdate();
                this.hot.instance.render();
            });
    }

    page(query: SearchQueryOptions): Observable<any> {
        this.saving = true;
        return this.api.event_light.searchMany(query).pipe(
            takeUntil(this.onDestroy),
            tap(response => {
                this.data = response.data;
                this.events_total = response.meta.count;
            }),
            // Caught here rather than downstream because this observable is the
            // PaginationDataSource's endpoint: letting the error out would kill the
            // datasource's own $page stream, which no catchError in resetDataSource
            // could recover. The tap above has not run when the fetch itself fails,
            // so this.data is still the rendered page; handleLoadError restores it
            // explicitly for the failures that happen after the tap.
            catchError(err => this.handleLoadError(err))
        );
    }

    /**
     * Report a failed load and swallow it. Returns EMPTY so the failure costs one
     * page rather than the subscription: an inner observable that completes without
     * emitting leaves its switchMap - and everything downstream of it - alive.
     */
    private handleLoadError(err): Observable<never> {
        this.saving = false;
        // The grid was never rebuilt, so it still shows lastRenderedPageIndex.
        // Assigning pageIndex does not emit `page`, so this cannot loop.
        if (this.paginator) {
            this.paginator.pageIndex = this.lastRenderedPageIndex;
        }
        // page() assigns this.data before afterPage runs, so a failure anywhere
        // after the event fetch leaves the model holding the page the grid never
        // rendered. The sheet stays interactive, and _eventIdFromCell /
        // _updateItemFromPaste resolve rows through this.data - so a click or a
        // paste would write to an event the user cannot see, and Save would
        // persist it. Roll the model back to the rows the grid is bound to.
        // When nothing has rendered yet there is no snapshot: leave this.data as
        // it is rather than blanking it, since insert() and every other reader
        // dereference it unconditionally.
        if (this.lastRenderedData) {
            this.data = this.lastRenderedData;
            this.events_total = this.lastRenderedTotal;
        }
        console.error('Event sheet: failed to load events', err);
        this.notification.openError('Could not load events for this sheet. See the browser console for details.');
        return EMPTY;
    }

    afterPage(response: ListResponse<WireEvent>): Observable<any> {
        this.saving = true;

        const event_ids = this.data.map(e => e.id);
        const constant_properties_ids = this.constant_properties.map(v => v.id);
        const atts = ['start', 'end'];
        const $eventConstants = this.customEventsData.getApiEventConstants(event_ids, constant_properties_ids, atts);
        const $linkedComponents = this.getLinkedComponents(response.data);
        return forkJoin([$eventConstants, $linkedComponents]).pipe(
            tap(([eventConstants, linkedComponents]) => {
                this.customEventsService.mapApiEventConstants(this.data, eventConstants, this.cp_id_dict);
                this.locked_dict = this.customEventsService.updateLockedProperties({}, this.data, this.constant_properties, eventConstants, atts);
                this.row_locked_dict = this.lockDataService.getRowLocked(this.data, this.locked_dict);
            }),
            map(() => response),
            switchMap((response) => this.getSelectedComponents(response)));
    }

    getSelectedComponents(response: ListResponse<WireEvent>) {
        // Get at least the components for the currently viewed events
        this.components = [];
        let $componentObs: Observable<ListResponse<WireComponent>>[] = [];
        this.component_type_map = {};
        const eventIds = response.data.map(e => e.id);
        this.component_types.forEach(ct => {
            const ops = new SearchQueryOptions();
            ops.filters = [
                getRelationWithIdFilter('component_type', ct.id)
            ];
            if (eventIds.length < 2000) {
                ops.filters.push(getManyRelationWithIdsFilter('events', eventIds));
            } else {
                ops.filters.push({
                    name: "events",
                    op: "any",
                    val: {and: this.getEventQuery()}
                });
            }

            $componentObs.push(this.api.component.searchMany(ops).pipe(
                tap((comp_results: ListResponse<WireComponent>) => {
                    if (!comp_results.data) {
                        return of([]);
                    }

                    // Via _updateComponentLists, not a bare concat: this is the only
                    // loader of components belonging to events in hot.change_ids
                    // (getLinkedComponents filters those out), and componentNameDict
                    // must never name a component componentDict cannot resolve - a
                    // paste of such a name is treated as already loaded, resolves to
                    // undefined and clears the cell.
                    this._updateComponentLists(comp_results.data);
                    this.component_type_map[ct.id] = comp_results.data;
                })
            ));
        });
        if ($componentObs.length > 0) {
            return forkJoin($componentObs).pipe(map(results => {
                if (!results) {
                    console.log('WARN: Event sheet view (page): No components corresponding to the selected Event Types ');
                    return
                }
                return response;
            }));
        } else {
            return of(response);
        }
    }

    private _refreshComponentQueries() {
        this.etCtQueryDict = this.customEventsService.getEventTypeComponentTypeQueryMap(this.eventTypeComponentTypes, this.config.component_type_date_filters, this.dtp);
    }

    private _isInitialized(): boolean {
        const hasEventTypes = this.eventTypes && this.eventTypes.length > 0;
        const hasEtCtDict = this.etCtDict !== undefined;
        return hasEventTypes && hasEtCtDict && !!this.dataSource;
    }

    protected readonly TOOLTIP_SHOW_DELAY = TOOLTIP_SHOW_DELAY;
}
